import makeStyles from '@material-ui/core/styles/makeStyles';

export const useRoomStyles = makeStyles( () => ({
    section: {
        paddingTop: '2em',
        paddingBottom: '3em',
    }
}) );